import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Cloud Native Learning Journey`}</h2>
    <p>{`The foundation of any modern cloud solution is a `}<strong parentName="p">{`Cloud Native
`}</strong>{` application. This core concept is formulated around a flexible platform
and open programming models. These programming models enable a wide range of
solutions to be constructed and delivered to users on top of an open
platform. To enable developers and architects to realise the value of
cloud native, IBM Cloud and Red Hat have delivered a world class cloud
open platform to support enterprise software and `}<strong parentName="p">{`Cloud Native
`}</strong>{` applications.`}</p>
    <p>{`This learning journey has been designed to take developers through a step by
step journey to build strong skills in both the programming models IBM is
aligned towards and the underlying platform. This platform is Red Hat
OpenShift, the multi/hybrid cloud kubernetes environment that provides developers extreme flexibility to build solutions for clients.`}</p>
    <p>{`This Learning Journey is targeted at the following  `}<a parentName="p" {...{
        "href": "https://www.ibm.com/garage/method/practices/think/practice_personas/"
      }}>{`personas`}</a>{`:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`The Cloud Native Developer`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`The DevSecOps Engineers`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`The Ops and SRE’s (`}<a parentName="strong" {...{
            "href": "https://en.wikipedia.org/wiki/Site_Reliability_Engineering"
          }}>{`Site Reliability Engineer`}</a>{`)`}</strong></li>
    </ul>
    <p>{`The learning journey is focused on using the `}<strong parentName="p">{`Partner Enterprise Sandbox`}</strong>{`. The
Sandbox provides full access to an IBM Cloud `}<strong parentName="p">{`Red Hat OpenShift Cloud
Platform`}</strong>{` development cluster which includes a set of CNCF open source
software development lifecycle tools to demonstrate how to use IBM Cloud
for full DevSecOps development.`}</p>
    <p>{`The learning journey agenda is broken into `}<strong parentName="p">{`Foundation`}</strong>{`, `}<strong parentName="p">{`Intermediate`}</strong>{` and `}<strong parentName="p">{`Advanced`}</strong>{` developer techniques and then extends with `}<strong parentName="p">{`Application Modernization`}</strong>{` and `}<strong parentName="p">{`Application Integration`}</strong>{`.`}</p>
    <p>{`Select the `}<strong parentName="p">{`Cloud Native Journey`}</strong>{` to select the style of how you want to
use the `}<strong parentName="p">{`Partner Enterprise Sandbox`}</strong>{`. You can use the self paced agenda or
work with the Partner Ecosystem team to have a remote workshop model. The self
paced model will enable longer term learning with the `}<strong parentName="p">{`Partner Enterprise
Sandbox`}</strong></p>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Developer Foundation" subTitle="Start your cloud native journey by learning the concepts, technologies & methodologies" href="/developer-foundation" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAADB0lEQVQozx2Q7TfbdxiHf288jEPtzV6spyMttejKZlW2Mk7iEKKqldQp7VahXaft6RQjTkQk8qQStJsuJad0iMhDqYog0qAjc3b8S9d+y4v7XPf3xfe6P/ctBFcjbGzuEwp/ZH0jxubWRyLRODvbUQ7ix2itNvpMDt7tH+L2+TBNTBPYiaAbczK95OFG208Yx52oNfd4PKBF+F/47n2M96E9kVG2d+NE947ZFoX/npwwbLfTPfKM3aM4c95lzJN/ENjaxjb1HPfyEqo77ZidU6judtJnGEFYW48mkoXCB2LSPcI7f7P74ZiD/SMiuxF6DDqeGseJHh3yxrfC5Mwcof0YjpcuXMse1D+2Y5t20dTxC5YXvyNs7cRFySGRD/8QOzhhPRxjen4G57wdRXUZPU/aGH3louvXXu4/esTD7n6sjimGTHYsIp/8NoRpcJDGajkyRT2Ce26e4GoI16ybP8WPs69dKFSV1HRUUN9QxoNWJYOWbkoq6yitUiCR5HKptJwrFTKqZAqqlc303WrhnryCpJRPECYmHSyKx13x+Zl1z+AV7zJkGaBU/TU/a5TUlRRx+vMzFFTdovgHJWclEqQXijgv/UpkIdKLxej7tTTIq8g8lYWwurbB27drLCwti1wlvBmm86GGwro8bg9cpbWrFpm6ge+a2si/+A2y6lo0nV309ukYHrFhHB1n0ROkvUVNWloagsfjJRAI8uavBfx+H8Ggn6uN9Zy+8Bl1LZfpMN3A4utnYs1AufJ7pNJCLl0uQ1F/DZW6lcZrzSgUDYnUGRkZCH5/EK93RZQGWFpcYNL5jJuqJoq/LaKmsoTrjWXc1jWjf/mUcvkVcvPyOZ//JV9k55CUlIQgCIlKT08jK0tcecxmxWY2MWrQYx7RYzEZcNgtOMesmI3DaLU99A485sWUg9qaGs5kZ5MvlXIuN08UfCqK0klNTU30iYRGvQ7bqBGrWBajQeSIOMDIxLg9wQf3NWju3kF98zry6koKCqRIzp4jJ0eSEKSkpJCcnExm5qnE+z91uv5ccfV2pgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "developer foundation",
              "title": "developer foundation",
              "src": "/ibm-cloudnative-journey/static/43c1b1f363561a677c0874f720a0d456/3cbba/developer-foundation.png",
              "srcSet": ["/ibm-cloudnative-journey/static/43c1b1f363561a677c0874f720a0d456/7fc1e/developer-foundation.png 288w", "/ibm-cloudnative-journey/static/43c1b1f363561a677c0874f720a0d456/a5df1/developer-foundation.png 576w", "/ibm-cloudnative-journey/static/43c1b1f363561a677c0874f720a0d456/3cbba/developer-foundation.png 1152w", "/ibm-cloudnative-journey/static/43c1b1f363561a677c0874f720a0d456/3c3d2/developer-foundation.png 1292w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Developer Intermediate" subTitle="Learn how to develop and deliver cloud native application with an Enterpeise SDLC" href="/developer-intermediate" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABf/AAAX/wEmlVevAAADNklEQVQozx2Sf0zUBRjGv/VHOVs4w36t1j+tWoutqRS7PBJl3i+II5gEBwEeIEeGIIQErEA9CALPaInzR6GgLJFKSEM6vLhD4KDySL2L291O5MfBcUCgUAHqp6+927Nne/943ud930eY8d3i/n1YXl7m3t17Ii8x7XXhH3dxd2Xl//7MrJdLRiOSEAkymYI/3W7mFhbwz/3FDZeLy729fNP8Hfn7PkPwTXi4s7goYoEFkRf/XmR82I53dIglUWxJFPX7x7B2mWgsL6IwTkFXZwcPyikK5xWXotuzlxhNCqroOATv8CC2q1acgxacjt+YFyc7rlu5Pe1h6Z95Vv69w9TETWZHPfSfrefr4mzmpie5es3OXl0Gqi2h7Cz4lCJ9DYmpOgS3vQdb/2V6v6/lD2s7Xt8k/QNXMFs6sVrN2GwDtBs7KDcc43BRLvFqNYX7KyjbV0p2jAz122+wVaVmzyd63gpXIERtjycrK5P42Ei2x0ajfieC+OQ0EvP2k1Go58xFEzs+zCUoOAxpeCRBGyVsi9VwoPog78ql7NJpqa8/QW1dHfklZQgbNyt5ZcMmXlsv4dXXQ3gpKJik9Gy6bQ7SdxfQ1NZB6q4cNoRsQrJFTmi4nIovDlN5/DQVBgOVVQeo/fIQR44fo76pCSFBl0PM++msD34TmVKFJimR6poqpudvs1N0Vqyv5siZFhIzc4hOyiBO+wF1Dd/SaurhxNlzlB40UKIvZ/dH+aRkpCG4vFM0tLSizdShVMlJSdXQ2tZMV6+ZrLwCsgpKGPLOcqGji1/7+rBc6ePiJRNtRhO1J09SUlVF7seFJKftIE7zHoIyKoYXXnyZwGefZ1XAEzz86GNUf3UU14SPUy0/0PxTJz2DN8QH9dHfbaHXZMJmMXNBjE6ZoYYErZZtSjnSUAlSqQThoUdWsXrNWgICnyTwmed4fO068YaZXPeM4B71ifByTQzv0PAInvEp2rsH+LHTTGNzIwkpCYSFb2arLAxFhAxVVCTCmnVP8wABgU+J7lYTrojA5nTjGpvk1sQMjpsj2BxOfrcPYXd5GPPPcf5nk7hiMp8fqqT9FyON59toEFHXdI7/AFeWVuu+hbaNAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "developer intermediate",
              "title": "developer intermediate",
              "src": "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/3cbba/developer-intermediate.png",
              "srcSet": ["/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/7fc1e/developer-intermediate.png 288w", "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/a5df1/developer-intermediate.png 576w", "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/3cbba/developer-intermediate.png 1152w", "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/0b124/developer-intermediate.png 1728w", "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/4ea69/developer-intermediate.png 2304w", "/ibm-cloudnative-journey/static/6cac4ff6b589fbd8488821bc98d899ef/6c165/developer-intermediate.png 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" title="Developer Advanced" subTitle="Learn advanced microservices techniques to develop and deliver cloud native applications" href="/developer-advanced" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAACwUlEQVQozy2S22/bZBiHvxyc+JT4ENtJHNuxXTcJ2dq16WGTyk7t1pUxNmVFK1K1quKwDYQQXIC0Ce2iEjcgwQ3cTULcIcYmccfNQEJM/C38FQ9fMi4e6ZVsP/69B1EulahWKijVKjVFoV6ro9ZnqGgSQ9dpmiZWoylpzLGbFo5l49oOgefT63TxWz6O4yFmslciZS7SNW0uMXUD0zAxjIbEpNmwpMjGsd05rtOSwpYUBvgS2/ZoB11EpVx+la5WQ1U1NFVHlzJjjoluyGRWS+LhtdoEfpdeN6YfpSS9PmmcyrpPluQU2SJCkekUpYam6TRkCsty59Fd18fzQsIwI44WSOJF8nRIno1Ik//rdDCvF1JJNpQMZi2XqctWZy21OxH9XL5YjImTgqgXMx4us7mxw9nNXVbPbLE8WuI1+XyUDyjijGG/T5HEhLLdsN1BqFKkyzlZrpyL15HSPj35d7+bE2RXCPJr+MGQ8coal/YOaIUXCQdXyNcPiJb3iVbusLh5k2R8gUYwQXhnj8i277N6+Bna4A6l9m0qxTHCXWNy/R+Wb/2GEALbUbl5+D79N/+gtPQN6d0XaFefIdaeUzx4yeSj36lNvkekV7+ge/sJ5z54SnzwM+70OfrWj5S9LVbe/pt8+id1ud2SlF6bTrn86b+I5GvGRy9obT9FjH4iuvcXzd1fqI1/QETbH+LsfIex8hUi/xwxeEj1zGNK1imipXso3buIUpmFnsPx/ceo2QllZwdz+B6V+BDRPia/fkLnrUe45x7JLTc8qk0XVd6UKFXl/dXkWThyIfKuxqs4ow3sYkK8scvrD044feOAyf67rF3eo9VQ5uNQqoJRUmF9JBBNVTDDMcv4doUwjuTHexSX9ulePCI8/w7Bxi28yQ3s0zuMph+z9cm3fPnrSx4+ecb5N+SCQsHklMGF9Tr/ASEEP1TxA0ZaAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "developer advanced",
              "title": "developer advanced",
              "src": "/ibm-cloudnative-journey/static/4ff6b39b47d8e55f2d374bf69d05c0a1/3cbba/developer-advanced.png",
              "srcSet": ["/ibm-cloudnative-journey/static/4ff6b39b47d8e55f2d374bf69d05c0a1/7fc1e/developer-advanced.png 288w", "/ibm-cloudnative-journey/static/4ff6b39b47d8e55f2d374bf69d05c0a1/a5df1/developer-advanced.png 576w", "/ibm-cloudnative-journey/static/4ff6b39b47d8e55f2d374bf69d05c0a1/3cbba/developer-advanced.png 1152w", "/ibm-cloudnative-journey/static/4ff6b39b47d8e55f2d374bf69d05c0a1/3c3d2/developer-advanced.png 1292w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <p>{`Before you jump straight into the Cloud Native learning journey, make sure
you have setup the necessary prerequisites, validated your Sandbox
environment and chosen the method you plan to use for you development tools.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      